import IBankPaymentRecordVm from "./IBankPaymentRecordVm"
import ICardProducerRequestVm from "./ICardProducerRequestVm"
import ICaseworkerVm from "./ICaseworkerVm"
import IFrendsReceiverRequestVm from "./IFrendsReceiverRequestVm"
import IInvoiceVm from "./../home/Payment/IInvoiceVm"
import { ErrorCaseStatusType } from "./../enums/ErrorCaseStatusType"
import { ErrorCaseType } from "./../enums/ErrorCaseType"
import { CertificateType } from "./../flags/CertificateType"

import * as ICaseworkerVmInstance from "./ICaseworkerVm"
import * as IBankPaymentRecordVmInstance from "./IBankPaymentRecordVm"
import * as IInvoiceVmInstance from "./../home/Payment/IInvoiceVm"
import * as ICardProducerRequestVmInstance from "./ICardProducerRequestVm"
import * as IFrendsReceiverRequestVmInstance from "./IFrendsReceiverRequestVm"

export default interface IErrorCaseVm {
    id: string
    errorNumber: number
    certificateType: CertificateType
    applicationId?: string
    applicationCertificateNumber?: number
    errorCaseType: ErrorCaseType
    errorMessage: string
    assignedCaseworker: ICaseworkerVm
    errorCaseStatus: ErrorCaseStatusType
    comment: string
    errornousBankFileId?: string
    errornousBankPaymentRecord: IBankPaymentRecordVm
    errornousInvoice: IInvoiceVm
    createdDate: string
    errornousCardProducerRequest: ICardProducerRequestVm
    errornousFrendsReceiverRequest: IFrendsReceiverRequestVm
}

export const empty = (enableIteration: boolean = true): IErrorCaseVm => {
	return {
		id: "",
		errorNumber: -1,
		certificateType: CertificateType.NotSet,
		applicationId: "",
		applicationCertificateNumber: -1,
		errorCaseType: ErrorCaseType.NotSet,
		errorMessage: "",
		assignedCaseworker: ICaseworkerVmInstance.empty(),
		errorCaseStatus: ErrorCaseStatusType.NotSet,
		comment: "",
		errornousBankFileId: "",
		errornousBankPaymentRecord: IBankPaymentRecordVmInstance.empty(),
		errornousInvoice: IInvoiceVmInstance.empty(),
		createdDate: "",
		errornousCardProducerRequest: ICardProducerRequestVmInstance.empty(),
		errornousFrendsReceiverRequest: IFrendsReceiverRequestVmInstance.empty()
	} as IErrorCaseVm
}